// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1r4MT","title":"Info_title__edhaD","selects":"Info_selects__oo7Gy","requiredAsterisk":"Info_requiredAsterisk__1zwyY"};